import { render, staticRenderFns } from "./BankCreateCost.vue?vue&type=template&id=ed57dbb2&"
import script from "./BankCreateCost.vue?vue&type=script&lang=js&"
export * from "./BankCreateCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports